<div
  #tasksList
  class="tasks-list"
  [class.empty-list]="tasks.length === 0 && !(addTaskMode$ | async)"
  (scroll)="onScroll()"
>
  <div
    *ngIf="addTaskMode$ | async"
    class="task-list-item-wrapper"
  >
    <mojo-add-task-item
      (clickOutside)="clickOutside()"
      (taskCreated)="taskCreated.emit($event)"
      (isAssignOpened)="setisAssignOpened($event)"
      (datePickerChangedState)="handleDatePickerState($event)"
      [width]="width"
    >
    </mojo-add-task-item>
  </div>
  <ng-container
    *ngIf="tasks.length > 0 || (addTaskMode$ | async); else emptyList"
  >
    <div
      class="task-list-item-wrapper"
      *ngFor="let task of tasks"
    >
      <mojo-task-list-item
        [task]="task"
        [sideDrawerConfiguration]="sideDrawerConfiguration"
      >
      </mojo-task-list-item>
    </div>
  </ng-container>

  <ng-template #emptyList>
    <span class="no-task-added-yet">No task added yet. Add the first one!</span>
  </ng-template>
</div>
